/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  /**
   * @param {string} message
   */
  announce(message) {
    const liveRegion = this.querySelector('#cart-drawer-live-region');
    if (!liveRegion || !message) return;
    liveRegion.textContent = '';
    requestAnimationFrame(() => {
      liveRegion.textContent = message;
    });
    const globalStatus = document.getElementById('cart-status');
    if (globalStatus) globalStatus.textContent = message;
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    this.cartAddHandler = this.handleCartAdd.bind(this);
    this.cartAfterMergeHandler = this.handleCartAfterMerge.bind(this);
    this.afterOpenHandler = this.handleAfterOpen.bind(this);
    this.cartRefreshHandler = this.cartRefreshHandler.bind(this);

    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.addEventListener('on:cart:add', this.cartAddHandler);
    document.addEventListener('on:cart:after-merge', this.cartAfterMergeHandler);
    this.addEventListener('on:cart-drawer:after-open', this.afterOpenHandler);

    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.removeEventListener('on:cart:add', this.cartAddHandler);
    document.removeEventListener('on:cart:after-merge', this.cartAfterMergeHandler);
    this.removeEventListener('on:cart-drawer:after-open', this.afterOpenHandler);
  }

  handleAfterOpen() {
    const closeBtn = this.querySelector('.drawer__close-btn');
    if (closeBtn) closeBtn.focus();
    const countEl = this.querySelector('.cart-drawer__title-count');
    const countText = countEl ? countEl.textContent.replace(/[()]/g, '').trim() : '';
    const itemWord = countText === '1' ? 'item' : 'items';
    this.announce(countText ? `Cart opened. ${countText} ${itemWord} in cart.` : 'Cart opened.');
  }

  handleCartAdd() {
    setTimeout(() => {
      const countEl = this.querySelector('.cart-drawer__title-count');
      if (countEl) {
        const countText = countEl.textContent.replace(/[()]/g, '').trim();
        this.announce(`Item added to cart. ${countText} items total.`);
      } else {
        this.announce('Item added to cart.');
      }
    }, 400);
  }

  handleCartAfterMerge() {
    theme.manuallyLoadImages(this);
    this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    const countEl = this.querySelector('.cart-drawer__title-count');
    if (countEl) {
      this.announce(`Cart updated. ${countEl.textContent.replace(/[()]/g, '').trim()} items.`);
    }
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
